import axios from 'axios'
import queryString from 'query-string'
// import store from './index'
// import router from '@/router'

const instance = axios.create({
  baseURL: `${process.env.VUE_APP_API_HOST}${process.env.VUE_APP_API_NAMESPACE}`,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

// instance.interceptors.response.use(undefined, function(err) {
//   if (process.env.NODE_ENV !== 'production') {
//     console.error('intercepted', err)
//   }

//   if (axios.isCancel(err)) {
//     return Promise.reject(err)
//   }

//   return new Promise(function() {
//     if (err.response.status === 401) {
//       store.dispatch('auth/logout')
//     }
//     if (err.response.status === 403) {
//       router.replace('/access-denied')
//     }
//     throw err.response
//   })
// })

export default instance

export function buildURL(url, query) {
  const { filter, ...rest } = query

  let params = {}

  if (filter) {
    Object.keys(filter).forEach(k => {
      if (filter[k] !== undefined && filter[k] !== null) {
        params[`filter[${k}]`] = filter[k]
      }
    })
  }

  Object.keys(rest).forEach(k => {
    if (rest[k] !== undefined && rest[k] !== null) {
      params[k] = rest[k]
    }
  })

  let suffix = queryString.stringify(params)

  if (suffix.length) {
    return `${url}${suffix}`
  }
  return url
}
